var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-home"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"ban-title"},[_vm._v("成人高考宝典APP")]),_c('div',{staticClass:"ban-subtitle"},[_vm._v("让学习成为习惯")]),_c('div',{staticClass:"ban-code"},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/img/qrcode.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }